import { BlockAction } from '../../types/panel'

interface Props {
  actions?: BlockAction[]
  onAction?: (action: BlockAction) => void
}

/** Aktionsleiste unter einem Block — k-btn im Kontor-Stil. */
export default function BlockActions({ actions, onAction }: Props) {
  if (!actions || actions.length === 0) return null
  return (
    <div className="k-frame__actions">
      {actions.map((a, i) => (
        <button
          key={i}
          className={'k-btn ' + (i === 0 ? 'k-btn--primary' : 'k-btn--ghost')}
          onClick={() => onAction?.(a)}
        >
          {a.label} <span className="arr">→</span>
        </button>
      ))}
    </div>
  )
}
